/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerCompanyUpdateAddressRequest
 */
export interface FreelancerCompanyUpdateAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyUpdateAddressRequest
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyUpdateAddressRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyUpdateAddressRequest
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyUpdateAddressRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerCompanyUpdateAddressRequest
     */
    region: string;
}

/**
 * Check if a given object implements the FreelancerCompanyUpdateAddressRequest interface.
 */
export function instanceOfFreelancerCompanyUpdateAddressRequest(value: object): value is FreelancerCompanyUpdateAddressRequest {
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('region' in value) || value['region'] === undefined) return false;
    return true;
}

export function FreelancerCompanyUpdateAddressRequestFromJSON(json: any): FreelancerCompanyUpdateAddressRequest {
    return FreelancerCompanyUpdateAddressRequestFromJSONTyped(json, false);
}

export function FreelancerCompanyUpdateAddressRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerCompanyUpdateAddressRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'],
        'city': json['city'],
        'zipCode': json['zipCode'],
        'countryCode': json['countryCode'],
        'region': json['region'],
    };
}

export function FreelancerCompanyUpdateAddressRequestToJSON(value?: FreelancerCompanyUpdateAddressRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'street': value['street'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'countryCode': value['countryCode'],
        'region': value['region'],
    };
}

